<template>
	<span class="help-feedback" :for="forElementId">
		<TruncatedValue :value="`${helpText}`" />
	</span>
</template>

<script>
import TruncatedValue from '@/components/shells/truncated-value/truncated-value.vue';
export default {
	name: 'HelpFeedback',
	components: {
		TruncatedValue
	},
	props: {
		helpText: {
			type: String,
			default: ''
		},
		forElementId: {
			type: [String, Number],
			default: ''
		}
	}
};
</script>

<style lang="scss" scoped>
.help-feedback {
	display: inline-block;
	font-size: $field-help-font-size;
	color: var(--field-fg-2);
	margin-top: $gutter-sm;
}
</style>
